import $ from 'jquery';
import Typed from 'typed.js'
import Vimeo from '@vimeo/player';

export default class MainSlider {
    constructor() {
        var self = this;
        if( typeof TYPE_WORDS !== 'undefined' && TYPE_WORDS.length > 0 )
            var typed = new Typed('.main-banner .words', {
                strings: TYPE_WORDS,
                typeSpeed: 125,
                backDelay: 3500,
                cursorChar: '',
                loop: true
        });

        if($('.modal').length > 0){
            $('.closeModalButton').click(function() {
                self.closeVideo();
            });

            $('.modal-button').click(function() {
                var videoModalButton = $(this);
                var modalID = videoModalButton.data('modal-id');
                if(videoModalButton.hasClass('casestudy-video')) {

                    // get the containing div and find the modal and iframe inside it
                    const $container = videoModalButton.closest('.js-case-study');
                    $container.find('.casestudyVideoModal').modal('show');
                    var $iframe = $container.find('.casestudyVideoModal iframe');
                } else {
                    $('[data-modal-window-id="' + modalID + '"]').not('.casestudyVideoModal').modal('show');
                    var $iframe = $('[data-modal-window-id="' + modalID + '"] iframe');
                }
                var iframeSrc = $iframe.data('src') != undefined ? $iframe.data('src') : $iframe.attr('src');
                if ($iframe.length > 0 && iframeSrc.indexOf('vimeo.com') != -1) {
                    var iframe = $iframe.get(0);
                    var player = new Vimeo(iframe);
                    player.play();
                } else if ($('.videoModal video').length > 0) {
                    $('.videoModal video').get(0).play();
                }
            });

            $(window).on('keyup', function(e) {
                if (e.keyCode == 27) {
                    self.closeVideo();
                }
            });

            if(document.cookie.indexOf("videoModal=") != -1) {
                self.closeVideo();
            }

            $('.videoModal').on('hidden.bs.modal', function (e) {
                self.closeVideo();
            });

            $('.videoModal .modal-body').on('click', function(e) {
                self.closeVideo();
            });

        }
    }

    closeVideo() {

        // close all modals
        $('.videoModal').modal('hide');

        // loop through all iframes inside modals
        $('.videoModal iframe').each((i, el) => {

            // check the source is vimeo
            var iframeSrc = $(el).data('src') != undefined ? $(el).data('src') : $(el).attr('src');
            if (iframeSrc.indexOf('vimeo.com') != -1) {

                // if so, pause the player
                var vimeoPlayer = new Vimeo(el);
                vimeoPlayer.pause();
            }
        });

        // loop through all HTML videos and pause them
        $('.videoModal video').each((i, el) => {
            el.pause();
        });

        document.cookie = 'videoModal=closed';
    }
}

new MainSlider();
